export const camelCaseToSpaced = camelCaseText => camelCaseText.replace(/([A-Z][a-z])/g, ' $1').replace(/(\d)/g, ' $1').trim()
